module.exports = __webpack_public_path__ + "static/media/logo-rgb.00c2d2ba.png";